import { ROUTES } from './routes'
import React, { ReactElement } from 'react'
import { StartScreen } from '../screens/start/StartScreen'
import { Route, Routes } from 'react-router-dom'
import { TrainingScreen } from '../screens/training/TrainingScreen'
import { ContactScreen } from '../screens/contact/ContactScreen'
import { RosterScreen } from '../screens/roster/RosterScreen'
import { WrestlerDetailScreen } from '../screens/roster/wrestler/WrestlerDetailScreen'
import { ImpressumScreen } from '../screens/impressum/ImpressumScreen'
import { MatchcardScreen } from '../screens/matchcard/MatchcardScreen'
import { SupporterScreen } from '../screens/supporter/SupporterScreen'
import { DatenschutzScreen } from '../screens/datenschutz/DatenschutzScreen'
import { AboutUsScreen } from '../screens/about-us/AboutUsScreen'

type FightbackRoute = {
  path: string
  element: React.ReactNode
  subRoutes?: FightbackRoute[] | undefined
}

const routes: Array<FightbackRoute> = [
  {
    path: ROUTES.start,
    element: <StartScreen />,
    subRoutes: [
      {
        path: ROUTES.matchcard,
        element: <MatchcardScreen />,
      },
    ],
  },
  {
    path: ROUTES.roster,
    element: <RosterScreen />,
    subRoutes: [
      {
        path: ROUTES.wrestler,
        element: <WrestlerDetailScreen />,
      },
    ],
  },
  {
    path: ROUTES.aboutUs,
    element: <AboutUsScreen />,
  },
  /* {
    path: ROUTES.events,
    element: <EventsScreen />,
  },*/
  {
    path: ROUTES.training,
    element: <TrainingScreen />,
  },
  {
    path: ROUTES.supporter,
    element: <SupporterScreen />,
  },
  {
    path: ROUTES.contact,
    element: <ContactScreen />,
  },
  {
    path: ROUTES.impressum,
    element: <ImpressumScreen />,
  },
  {
    path: ROUTES.datenschutz,
    element: <DatenschutzScreen />,
  },
]

export const FightbackRoutes = (): ReactElement => {
  return (
    <Routes>
      {routes.map((route): ReactElement => {
        if (route.subRoutes !== undefined) {
          return (
            <Route key={route.path} path={route.path}>
              <Route index={true} element={route.element} />
              {route.subRoutes.map((subRoute): ReactElement => {
                return <Route key={subRoute.path} path={subRoute.path} element={subRoute.element} />
              })}
            </Route>
          )
        }
        return <Route key={route.path} path={route.path} element={route.element} />
      })}
    </Routes>
  )
}
